import styled from '@emotion/styled';


const SecondModal:React.FC<any> = ({ showModal, closeModal }) => {
  
  return (
    <>
    {showModal ? 
      <Background  onClick={closeModal}>
        <ModalContainer>
          <CloseContainer onClick={closeModal}>x</CloseContainer>
          <BodyImgContainer>
            <Img src="/images/newLanding/home/familyWithBook.png"/>
          </BodyImgContainer>
        </ModalContainer>
      </Background>: null}
    </>
  )
};

export default SecondModal;

const Background = styled.div`
  position:fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.50);
  z-index: 0;
`;
const ModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: scroll;
  max-height: 80%;
  width: 343px;
  height: 90%;
  background-color: white;
  text-align: center;
  display:flex;
  flex-direction: column;
`;
const CloseContainer = styled.div`
  display: flex;
  justify-content: end;
  font-size: 20px;
  margin-right: 10px;
  position: fixed;
  top: 1%;
  left: 93%;
`;

const BodyImgContainer = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`